module.exports = __webpack_public_path__ + "img/organization-unfold.d7b3aa99.svg";